/**
 * #665 — the shared K Δ/m / P Δ/m cell VALUE. One renderer for every
 * depth-velocity cell (GameTable rows, SpreadsTotals/GameDetail line rows) so
 * the three lifecycle states cannot drift between surfaces:
 *
 *   ready       → the signed delta, exactly as before (including truthful 0);
 *   warming     → a compact ellipsis with the accessible one-minute
 *                 explanation. Same single character width class as the
 *                 dash so dense rows keep their rhythm — no reflow;
 *   unavailable → the same bare `—` as before (no book, no samples, or a
 *                 stalled sample stream).
 *
 * The caller owns the <span class="inline-block w-[7ch]"> width shell and the
 * tone class (depthDeltaTone(null) is the muted tone for both non-ready
 * states), so this component adds no geometry of its own.
 */
import {
  DEPTH_WARMUP_LABEL,
  formatSignedVolume,
  type DepthVelocityDisplay,
} from './bookDepthVelocity';

export function DepthVelocityValue({ display }: { display: DepthVelocityDisplay }) {
  if (display.kind === 'ready') return <>{formatSignedVolume(display.delta)}</>;
  if (display.kind === 'warming') {
    return (
      <span aria-label={DEPTH_WARMUP_LABEL} title={DEPTH_WARMUP_LABEL}>
        …
      </span>
    );
  }
  return <>—</>;
}
